export default __webpack_public_path__ + "static/media/apple_store_white.30e2687a.webp";